const e = "cmp", n = otto.cmp, {
  allowAll: t,
  rejectAll: o,
  togglePreferenceCenter: s,
  resurfaceBanner: r,
  rejectGeneralVendorConsent: C,
  getConsentForGV: c,
  getConsentsForAllGVs: g,
  getIabConsentString: a,
  readVendorsConsents: A,
  readConsentsStates: l,
  archiveReceipt: p,
  emitConsentChangeEvent: E,
  getOttoOwnPurposesConsent: P,
  getAppGoogleTrackingConsent: S,
  getAdjustTrackingConsent: d,
  processAppConsentV2: i,
  consentChanged: M,
  showVendorsList: N
} = otto.cmp;
export {
  e as NEXUS_CMP_NAMESPACE,
  t as allowAll,
  p as archiveReceipt,
  n as cmp,
  M as consentChanged,
  E as emitConsentChangeEvent,
  d as getAdjustTrackingConsent,
  S as getAppGoogleTrackingConsent,
  c as getConsentForGV,
  g as getConsentsForAllGVs,
  a as getIabConsentString,
  P as getOttoOwnPurposesConsent,
  i as processAppConsentV2,
  l as readConsentsStates,
  A as readVendorsConsents,
  o as rejectAll,
  C as rejectGeneralVendorConsent,
  r as resurfaceBanner,
  N as showVendorsList,
  s as togglePreferenceCenter
};
